import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuetify from "@/plugins/vuetify";

Vue.use(VueI18n);

function deepMerge(target, source) {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key]) &&
      result[key] &&
      typeof result[key] === "object" &&
      !Array.isArray(result[key])
    ) {
      result[key] = deepMerge(result[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/^\.\/([A-Za-z0-9-_]+)(?:\/|\.json)/);
    if (matched && matched[1]) {
      const locale = matched[1];
      messages[locale] = deepMerge(messages[locale] || {}, locales(key));
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "it",
  fallbackRoot: true, // Utilizza la chiave come fallback
  messages: loadLocaleMessages(),
  missing: (locale, key) => {
    return key;
  },
});

export default i18n;

export function setI18nLanguage(lang) {
  i18n.locale = lang;
  Vuetify.framework.lang.current = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}
